export default "__VITE_ASSET__BQtvc3RG__"